import React from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';

import FacebookIcon from '@/assets/svg/socials/facebook.svg';
import VkontakteIcon from '@/assets/svg/socials/vk.svg';
import OdnoklassnikiIcon from '@/assets/svg/socials/ok.svg';
import useConstant from '@/hooks/useConstant';
import share from '@/utils/share';
import { colors } from '@/constants/theme';

function ShareWithYourFriends() {
  const router = useRouter();
  const currentPath = router.asPath;

  const ITEM_LIST = useConstant(
    () =>
      [
        { id: 'facebook', icon: FacebookIcon },
        { id: 'vk', icon: VkontakteIcon },
        { id: 'odnoklassniki', icon: OdnoklassnikiIcon },
      ] as const
  );

  return (
    <Section>
      <Component>
        <ComponentContainer>
          <Label>Поделись с друзьями</Label>
          <SocialList>
            {ITEM_LIST.map((item, index) => (
              <SocialItem
                key={index}
                onClick={() => share(item.id, currentPath)}
              >
                <Social>
                  <SocialIcon>{React.createElement(item.icon)}</SocialIcon>
                </Social>
              </SocialItem>
            ))}
          </SocialList>
        </ComponentContainer>
      </Component>
    </Section>
  );
}

export default ShareWithYourFriends;

const Section = styled.section`
  position: relative;
  margin-top: 127px;
`;

const Component = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: -35px;

  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
  max-width: calc(1546px + 40px);

  @media (min-width: 1400px) {
    bottom: -50%;
    transform: translateY(50%);
  }
`;

const ComponentContainer = styled.div`
  @media (min-width: 1400px) {
    display: flex;
    align-items: center;
    background: ${(props) => props.theme.white_1};
    box-shadow: ${(props) => props.theme.blackShadow100};
  }
`;

const Label = styled.span`
  font-weight: 700;
  font-size: 20px;
  line-height: 140%;
  color: ${(props) => props.theme.black100};

  @media (min-width: 1400px) {
    padding: 30px 100px;
    flex: 1 0 0;

    text-align: left;
    font-size: 25px;
  }
`;

const SocialList = styled.ul`
  display: flex;
  align-items: center;
  align-self: stretch;
  margin-top: 20px;
  box-shadow: ${(props) => props.theme.blackShadow100};
  background: ${(props) => props.theme.white_1};

  @media (min-width: 1400px) {
    width: 100%;
    max-width: 672px;
    box-shadow: none;
    margin-top: 0;
  }
`;

const SocialItem = styled.li`
  display: flex;
  align-items: center;
  align-self: stretch;

  width: 100%;
  max-width: 100%;
  flex: 1 0 0%;
`;

const Social = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;

  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    background: ${colors.main};
    transform: scale(1.1);
    box-shadow: rgb(0 0 0 / 20%) 0 3px 9px;
    z-index: 999;

    & > span {
      svg {
        path {
          fill: ${colors.white};
        }
      }
    }
  }
`;

const SocialIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 68px;
  height: 68px;
  transition: color 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  svg {
    width: 30px;
    height: 30px;

    path {
      fill: ${(props) => props.theme.main};
    }
  }
`;
